module.exports = __webpack_public_path__ + "img/home-four-1.c14c0f3a.jpg";